module.exports = __webpack_public_path__ + "static/media/MTL_SL_RUSH2.44af17f5.png";